import React from 'react';
import FingerprintOne from '@grnhse/seedling/lib/birch/illustrations/fingerprint_one';
import { EmptyState } from '@grnhse/seedling/lib/birch/components/empty_state';
import { SecondaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { withLocalePrefix } from 'shared/utils/translation';

const t = withLocalePrefix('talent_matching.rediscovery.empty_state');

type RediscoveryNoResultsOverlayProps = {
  userDateFormat: string;
  hasAnyFilters: boolean;
  onClearAll: () => void;
};

const RediscoveryNoResultsOverlay = ({
  hasAnyFilters,
  onClearAll,
}: RediscoveryNoResultsOverlayProps) => {
  return (
    <Stack sx={{ marginTop: 5 }}>
      {hasAnyFilters ? (
        <EmptyState
          header={t('no_results_header')}
          body={t('no_results_body')}
          Illustration={FingerprintOne}
          size="sm"
        >
          <SecondaryButton onClick={onClearAll}>
            {t('clear_all_filters')}
          </SecondaryButton>
        </EmptyState>
      ) : (
        <EmptyState
          header={t('no_candidates_header')}
          body=""
          Illustration={FingerprintOne}
          size="sm"
        />
      )}
    </Stack>
  );
};

export default RediscoveryNoResultsOverlay;
